module.exports = __webpack_public_path__ + "static/media/Terms-And-Conditions.78eb58e4.svg";